export default __webpack_public_path__ + "static/media/newLogo.374e6ad0.png";